<script>
import {ExhibitorMixin} from "../lib/speaker-utils.js"
import Favorite from "../lib/favorite.vue"

export default {
  mixins: [ExhibitorMixin],
  components: {Favorite},
  props: {
    exhibitorType: {type: String, default: 'exhibitor'},
    exhibitor: {type: Object, required: true},
    listDisplay: {type: Boolean, default: true},
  },

  data() {
    return {
      descriptionVisible: false,
      emailVisible: false
    }
  },

  computed: {
    userIsLoggedIn() {
      return this.$storage.getToken()
    }
  },

  created() {
  },

  methods: {
    mailToLink() {
      return `mailto:${this.exhibitor.email}`
    },
    website(url) {
      if (!url) return url
      if (url.startsWith('http')) return url
      return 'https://' + url
    },
  },


}
</script>

<template>
    <div class="row">
          <div class="col col-3 col-lg-2">
            <img v-if="exhibitor.logo" class="img-thumbnail" :src="exhibitor.logo" :alt="exhibitor.company_name">
            <img v-else class="img-thumbnail" src="/media/app/company-symbol.png" alt="company symbol" />
          </div>
          <div class="col col-9 col-lg-10">
            <div class="row">
              <div class="col-8 mb-3">
                <div>
                  <router-link v-if="listDisplay" :to="exhibitorUrl(exhibitor)">
                    {{ exhibitor.company_name }}
                  </router-link>
                  <span v-else>{{ exhibitor.company_name }}</span>

                  <favorite :attr="exhibitorType" :value="exhibitor.sfid" :obj="exhibitor"
                   @favorite-changed="$emit('favorite-changed', $event)" />
                </div>
                <p>{{ exhibitor.address }}</p>
                <div v-if="exhibitor.type != 'Exhibitor'" class="c-title pb-2">
                  <i class="fas fa-trophy"></i>&nbsp;{{ exhibitor.type }}
                </div>

                <span v-if="userIsLoggedIn && exhibitor.email">
                <button @click="emailVisible=true" class="btn btn-sm btn-secondary">Kontakt</button>
                <a v-if="emailVisible" :href="mailToLink()" class="mail-link">per Mail.</a>
                </span>

                <!--div v-if="exhibitor.website"><i class="fas fa-globe"></i>&nbsp;<a :href="website(exhibitor.website)" target="_blank">{{ exhibitor.website }}</a></div-->
              </div>

              <div class="col col-4">
                <div>Halle: {{ exhibitor.hall }}</div>
                <div>Stand: {{ exhibitor.stand }}</div>
              </div>

              <div v-if="exhibitor.description && listDisplay" 
               class="col col-12 mb-3 d-none d-lg-block">
                {{ exhibitor.description }}
              </div>
            </div>
          </div>

          <div v-if="exhibitor.description && listDisplay" class="col col-12 pt-3 d-lg-none">
            <a href="#" class="btn btn-outline float-end"
            @click.prevent="descriptionVisible=!descriptionVisible">
              <i v-if="descriptionVisible" class="fa fa-chevron-down"></i>
              <i v-else class="fa fa-chevron-right"></i>
            </a>
            <div v-if="descriptionVisible">{{ exhibitor.description }}</div>
            <div v-else class="c-truncate">{{ exhibitor.description }}</div>
          </div>

          <div v-if="exhibitor.description && !listDisplay" class="col col-12 pt-3">
            {{ exhibitor.description }}
          </div>

      <slot></slot>
    </div>
</template>

<style scoped>

.c-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.c-session {
  border-top: 1px solid lightgrey;
}

hr {
  border-color: lightgrey;
}

.avatar {
  height:100px;
  width:100px;
  object-fit:cover;
  border-radius:50%;
  overflow:hidden;
}

.mail-link {
  text-decoration: underline;
}

</style>
